import { create } from "zustand";
import produce from "immer";
import * as api from "../services/delivery_note_templates";
import { arrayToByIdsAllIds, createLatestRequestTracker } from "./utils";

const trackListRequest = createLatestRequestTracker();

export const useDeliveryNoteTemplatesStore = create((set) => ({
  byIds: {},
  allIds: [],
  selectedId: null,
  total: 0,
  fetchSome: async ({ q = "", limit = 20, offset = 0 }) => {
    const isLatestRequest = trackListRequest();
    const some = await api.getSome({ q, limit, offset });
    if (!isLatestRequest()) return;
    set(
      produce((draft) => {
        [draft.byIds, draft.allIds] = arrayToByIdsAllIds(some.data);
        draft.total = some.total;
      }),
    );
  },
  getById: async ({ id }) => {
    const one = await api.getById({ id });
    set(
      produce((draft) => {
        draft.byIds[one.data.id] = one.data;
        if (!draft.allIds.includes(one.data.id)) {
          draft.allIds.push(one.data.id);
        }
        draft.selectedId = one.data.id;
      }),
    );
  },
  setSelectedId: async ({ id }) => {
    set(() => ({ selectedId: id }));
  },
  createOne: async ({ name, item_ids, documentation_schema, documentation }) => {
    const one = await api.createOne({
      name,
      item_ids,
      documentation_schema,
      documentation,
    });
    if (!!one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
          draft.allIds.unshift(one.data.id);
        }),
      );
    }
    return one;
  },
  updateOne: async ({
    id,
    name,
    item_ids,
    documentation_schema,
    documentation,
  }) => {
    const one = await api.updateOne({
      id,
      name,
      item_ids,
      documentation_schema,
      documentation,
    });
    if (!!one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
        }),
      );
    }
    return one;
  },
  deleteOne: async ({ id }) => {
    const result = await api.deleteOne({ id });
    if (!result.error) {
      set(
        produce((draft) => {
          delete draft.byIds[id];
          draft.allIds = draft.allIds.filter((aid) => aid !== id);
          draft.total = Math.max(0, draft.total - 1);
        }),
      );
    }
    return result;
  },
}));
